import ApiRoutes from "../../../../constants/api-routes";
import { hneAdminApi } from "../../../../service";

export const createNewSubscription = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEW_SUBSCRIPTION}`, body);
